import { QueryClient } from '@tanstack/react-query'

/** Returns an account-scoped query key under the shared account root. */
export function queryKey(address: string | null | undefined, ...parts: readonly unknown[]) {
  return ['account', address?.toLowerCase() ?? null, ...parts] as const
}

/** Cancels and removes every cached query under one account root. */
export async function clear(queryClient: QueryClient, address?: string | null | undefined) {
  if (!address) return
  await queryClient.cancelQueries({ queryKey: queryKey(address) })
  queryClient.removeQueries({ queryKey: queryKey(address) })
}
